import { render } from "./TextEditor.vue?vue&type=template&id=b4da318c"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=b4da318c&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__